import classNames from "classnames";
import { getProfileName } from "PFCore/helpers/profile";
import ErrorIcon from "PFIcons/error.svg";
import WarningIcon from "PFIcons/warning.svg";
import PropTypes from "prop-types";
import React, { useCallback, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import { isOverbooked } from "./helpers";
import ReviewBookingModal from "./modals/review_booking_modal";
import css from "./resource.module.scss";
import YellowWarningIcon from "./yellow_warning_icon";

const Resource = ({ role, reviewedShortlistIds, setReviewedShortlistIds, engagement }) => {
  const { t } = useTranslation("auditPlanner");
  const [showModal, setShowModal] = useState(false);
  const shortlist =
    role.shortlists && role.shortlists.find(({ state }) => ["booked", "filled", "confirmed"].includes(state));
  const profile = shortlist?.profile;
  const hasExceptions = shortlist?.exceptions?.length > 0;
  const isReviewed = shortlist && reviewedShortlistIds.includes(shortlist.id);
  const openModal = useCallback(() => {
    setShowModal(true);
    if (shortlist && !isReviewed && ["filled", "booked"].includes(role.workflow_state)) {
      setReviewedShortlistIds([...reviewedShortlistIds, shortlist.id]);
    }
  }, [isReviewed, reviewedShortlistIds]);

  const namedResource = profile && role.staff_number && profile.source_id === role.staff_number;
  const username = getProfileName(profile);

  return (
    <div>
      {profile ? (
        <>
          <Link
            className={css.aligned}
            to={`/profiles/${profile.id}`}
            alt={namedResource ? "Named resource" : username}
            title={namedResource ? t("parts.namedResource") : username}
          >
            <img
              className={classNames(css.avatar, {
                [css.named]: namedResource
              })}
              src={profile.avatar.thumbnail_url}
              alt={namedResource ? "Named resource" : username}
              title={namedResource ? t("parts.namedResource") : username}
            />
            {username}
          </Link>
          {hasExceptions && <WarningIcon className={css.exceptionIcon} width={30} height={30} />}
          {isOverbooked(role) && (
            <YellowWarningIcon
              onClick={openModal}
              className={classNames(css.warningIcon, {
                [css.reviewed]: isReviewed
              })}
              width={30}
              height={30}
              viewBox="0 0 20 20"
            />
          )}
        </>
      ) : (
        <ErrorIcon width={18} height={18} viewBox="0 0 25 25" className={css.noResource} />
      )}
      {showModal && (
        <ReviewBookingModal
          role={role}
          shortlistItem={shortlist}
          close={() => setShowModal(false)}
          engagement={engagement}
        />
      )}
    </div>
  );
};

Resource.propTypes = {
  role: PropTypes.object.isRequired,
  reviewedShortlistIds: PropTypes.arrayOf(PropTypes.number).isRequired,
  setReviewedShortlistIds: PropTypes.func.isRequired,
  engagement: PropTypes.object.isRequired
};

export default Resource;
